import React from 'react';

const BouncingLogo = () => {
  return (
    <div className="bouncingLogo">
      <svg
        imageRendering="auto"
        baseProfile="basic"
        x="0px"
        y="0px"
        width={130}
        height={190}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(.234 0 0 .5 40 179)">
          <animateTransform
            attributeName="transform"
            additive="replace"
            type="translate"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.444;.55599;.963;1"
            values="39.997,179;15.048,179;15.048,179;39.997,179;39.997,179"
          />
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="scale"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.444;.55599;.963;1"
            values=".234,.5;.479,.5;.479,.5;.234,.5;.234,.5"
          />
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="translate"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.444;.55599;.963;1"
            values="-.2,0;-.1,0;-.1,0;-.2,0;-.2,0"
          />
          <path
            fill="#EEE"
            d="M214 6.5q0-2.7-31.35-4.6Q151.3 0 107 0 62.7 0 31.35 1.9 0 3.8 0 6.5q0 2.7 31.35 4.6Q62.7 13 107 13q44.3 0 75.65-1.9Q214 9.2 214 6.5z"
          />
        </g>
        <g transform="matrix(.498 0 0 .498 8.75 1.3)">
          <animateTransform
            attributeName="transform"
            additive="replace"
            type="translate"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.333;.444;.556;.889;1"
            values="65.261,43.01;65.261,126.83;65.261,147.96;65.261,126.862;65.261,43.055;65.261,43.055"
          />
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="scale"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.333;.444;.556;1"
            values=".498,.498;.498,.498;.498,.417;.498,.498;.498,.498"
          />
          <animateTransform
            attributeName="transform"
            additive="sum"
            type="translate"
            repeatCount="indefinite"
            dur="1.125s"
            keyTimes="0;.333;.444;.556;1"
            values="-113.5,-83.85;-113.5,-83.9;-113.5,-84.05;-113.5,-83.95;-113.5,-83.95"
          />
          <path
            fill="#019DF4"
            d="M215.4 23.3q-4.5-10.5-11.45-16.45-7.2-6.2-16.2-6.8-10.55-.65-20.6 5.9-10.65 7-16.55 19.6-4.45 9.5-10 23.35-6.65 16.45-7.15 17.6-2.85 6.6-7 10.2-4.35 3.8-10.45 4.45-7.3.75-14.15-4.1-6.15-4.4-11.3-12.8-5.9-9.65-11.2-17.55-7.5-11.2-11.45-15.05-6.15-6.1-9.75-8.3-6.8-4.1-15.55-3.95-11.15.15-20 7.25Q9.7 37 3.85 60.9.75 73.55.15 85.4-.5 98.7 1.8 112.7q2.1 12.25 5.85 24.6 2.95 9.8 6.25 17.55 1.85 4.45 4.7 7.95 2.9 3.65 7.75 4.4 3.9.55 6.75-.75 3.05-1.55 4.6-4.5 2-3.95 1.1-10-.7-4.65-3.65-14.15-4.35-14.15-5.15-17.05-2.65-9.95-2.9-15.95-.35-8.15 2.4-11.75 1.7-2.2 5.2-2.95 3.75-.85 7.6 2.85 3.05 2.9 6.75 9.4 2.6 4.5 9.9 17.3Q66 131.95 70.4 139.3q5.75 9.7 14.15 15.35 10.55 7.05 23.8 6.5 15.85-.65 25.55-7.45 10.95-7.7 16.3-24.65 6.5-20.6 7.6-23.85 4-11.85 8-20.75 5.35-11.75 11.95-17.55 6.6-5.8 12.55-3.9 5.25 1.7 7.4 7.05 1.8 4.5 1.9 13.15.1 9.85-1.85 27.35-.85 8-.65 11.4.4 5.1 2.55 8.45 2.6 3.95 7.35 4.6 5.2.75 9.6-2.85 3.95-3.3 5.85-8.9 1.3-4.1 2.1-10.05 1.65-11.6 2.05-20.3.4-9.15-.3-20.55-1.75-27.9-10.9-49.05z"
          />
        </g>
      </svg>
    </div>
  );
};

export default BouncingLogo;
